import api, { refreshCurrentSession } from "./api";
import { getStoredToken } from "../auth/session";

const getApiBaseUrl = () =>
  api.defaults.baseURL ||
  process.env.REACT_APP_API_URL ||
  `${window.location.protocol}//${window.location.hostname}:3033`;

const toMediaUrl = (path) => {
  if (typeof path !== "string" || !path.startsWith("/media/")) {
    throw new MediaRequestError(400, "Localizador de mídia inválido");
  }

  const apiBaseUrl = new URL(getApiBaseUrl(), window.location.origin);
  apiBaseUrl.pathname = `${apiBaseUrl.pathname.replace(/\/+$/, "")}/`;
  apiBaseUrl.search = "";
  apiBaseUrl.hash = "";

  return new URL(path.replace(/^\/+/, ""), apiBaseUrl).toString();
};

const requestMedia = async (url, token, options = {}) => {
  const headers = new Headers(options.headers || {});
  if (token) headers.set("Authorization", `Bearer ${token}`);
  return fetch(url, { ...options, credentials: "omit", headers });
};

export class MediaRequestError extends Error {
  constructor(status, message = "Não foi possível carregar a mídia") {
    super(message);
    this.name = "MediaRequestError";
    this.status = status;
  }
}

/**
 * Fetches a domain media endpoint with bearer authentication. The first 401
 * retries with a newer token already persisted by another request, otherwise
 * it performs the shared refresh once. Tokens never enter the URL.
 */
export const fetchMediaBlob = async (path, options = {}) => {
  const url = toMediaUrl(path);
  let token = getStoredToken();
  let response = await requestMedia(url, token, options);

  if (response.status === 401) {
    const currentToken = getStoredToken();
    if (currentToken && currentToken !== token) {
      token = currentToken;
      response = await requestMedia(url, token, options);
    } else if (await refreshCurrentSession()) {
      token = getStoredToken();
      response = await requestMedia(url, token, options);
    }
  }

  if (!response.ok) {
    throw new MediaRequestError(response.status);
  }

  const contentType = response.headers
    .get("content-type")
    ?.split(";", 1)[0]
    .trim()
    .toLowerCase();

  if (!contentType?.startsWith("image/")) {
    throw new MediaRequestError(502, "Resposta de mídia inválida");
  }

  const blob = await response.blob();

  if (blob.type && !blob.type.toLowerCase().startsWith("image/")) {
    throw new MediaRequestError(502, "Resposta de mídia inválida");
  }

  return blob;
};

export const createMediaObjectUrl = (blob) =>
  blob ? URL.createObjectURL(blob) : "";

export const revokeMediaObjectUrl = (url) => {
  if (url) URL.revokeObjectURL(url);
};
